/***
 * 创建人：李珊
 * 时间：2020-02-06
 * 描述: 查看素材详情-新增或编辑表格
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmsService } from '../../../../kms.service';
@Component({
  selector: 'app-table-addorupdate',
  templateUrl: './table-addorupdate.component.html',
  styleUrls: ['./table-addorupdate.component.css']
})
export class TableAddorupdateComponent implements OnInit {
  //弹出层组件
  @ViewChild('modal') modal: SwModalframeComponent; 
  //输入参数
  @Input() param: any;  
  //抛出事件
  @Output() callback = new EventEmitter(); 
  //标题
  headerLoGo:string;   
  formModel:any = {};   
  //保存按钮是否可点击
  clickEnable = true;

  constructor(
    private kmsService: KmsService,
    private box:SwMassageBoxService
  ) { 

  }

  ngOnInit() {
    // 查询表格详情
    this.clickLoca(this.param);
  }

  clickLoca(params: any){
    this.formModel.materialRelId = params.materialRelId;
    let upOrAddStr;
    //当前操作为编辑时
    if(params.upOrAdd == "Edit"){
      upOrAddStr = '编辑';
      this.headerLoGo = upOrAddStr + '表格';
      this.getDetailById();
    }else{//当前操作为新增时
      upOrAddStr = '新增';
      this.headerLoGo = upOrAddStr + '表格';
      this.formModel.parentMaterialId = params.materialId;
      this.formModel.relType = 2;
    }
  }

  // 根据主键id查询目录信息
  getDetailById() {
    this.kmsService.queryMaterialPicOrTableById(this.formModel.materialRelId).subscribe(
      data => {
        if (data.code == 200) {
          this.formModel = data.data;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  //表单提交
  onSubmit({ value, valid }, event: Event) {
    this.clickEnable = false;
    let func;
    if(this.param.upOrAdd == 'Add'){
      func = this.kmsService.saveMaterialRel(this.formModel);
    }else{
      func = this.kmsService.updateMaterialRel({
        "materialRelId": this.formModel.materialRelId,
        "name": this.formModel.name,
        "pagesNum": this.formModel.pagesNum
      });
    }
    func.subscribe(data => {
      this.clickEnable = true;
      if (data['code'] == 200) {
        this.box.success('保存成功!');
        // 关闭框
        this.modal.toggle();
        // 回调
        this.callback.emit(true);
      } else {
        this.box.danger('保存失败!');
      }
    });
  }
}


